import _ from 'lodash';
import moment from 'moment';
import { numConvert } from "@/method";
import { setKarte } from '@/method/analysis';
import request from '@/method/request';
const correspondData7_7 = {
    // 19: 1,
    20: 2,
    21: 3,
    27: 5,
    28: 6,
    29: 7,
    35: 9,
    36: 10,
    37: 11,
    43: 13,
    44: 14,
    45: 15,
    51: 17,
    52: 18,
    53: 19,
    60: 21,
    62: 22,
    63: 23,
};

export const getChart = async year => {

    const { data: { data = [], fb = [], room = [], total } } = await request(`/chartData7_8?year=${year}`);
    const dataX = new Array(12).fill(1).map((x, i) => `${i + 1}月`);
    setKarte({
        id: "row1",
        title: "酒店整体人效指数",
        color: ['#00C5BD', '#42585D', '#FE5F5F'],
        yAxis: {
            min: 0, interval: 0.5, max: 5
        },
        dataX, dataY: [
            {
                name: "今年",
                data: dataX.map((x, i) => numConvert(_.get(data.find(_x => _x.month == (i + 1)), 'now_year', 0)).toFixed(2))
            },
            {
                name: "去年",
                data: dataX.map((x, i) => numConvert(_.get(data.find(_x => _x.month == (i + 1)), 'last_year', 0)).toFixed(2))
            },
            {
                name: "预算",
                data: dataX.map((x, i) => numConvert(total).toFixed(2))
            }
        ]
    });

    setKarte({
        id: "row2",
        title: "F&B人效指数",
        color: ['#00C5BD', '#42585D', '#FE5F5F'],
        yAxis: {
            min: 0, interval: 1, max: 10
        },
        dataX, dataY: [
            {
                name: "今年",
                data: dataX.map((x, i) => numConvert(_.get(fb.find(_x => _x.month == (i + 1)), 'now_year', 0)).toFixed(2))
            },
            {
                name: "去年",
                data: dataX.map((x, i) => numConvert(_.get(fb.find(_x => _x.month == (i + 1)), 'last_year', 0)).toFixed(2))
            }
        ]
    });

    setKarte({
        id: "row3",
        title: "Rooms人效指数",
        color: ['#00C5BD', '#42585D', '#FE5F5F'],
        yAxis: {
            min: 0, interval: 1, max: 10
        },
        dataX, dataY: [
            {
                name: "今年",
                data: dataX.map((x, i) => numConvert(_.get(room.find(_x => _x.month == (i + 1)), 'now_year', 0)).toFixed(2))
            },
            {
                name: "去年",
                data: dataX.map((x, i) => numConvert(_.get(room.find(_x => _x.month == (i + 1)), 'last_year', 0)).toFixed(2))
            }
        ]
    });

}

export default ({ data, date, data7_7 }) => {
    const month = moment(date).format('M');
    data[19].now_year = month;
    data[19].last_year = month;
    Object.entries(correspondData7_7).forEach(item => {
        data[item[0]].now_year = _.get(data7_7, `${item[1]}.actual`);
        data[item[0]].last_year = _.get(data7_7, `${item[1]}.last`);
    });

    return data;
}


// WEBPACK FOOTER //
// ./src/hr/table/9.0/compute.js